import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useRxForm } from '../../../../components/RxForm/hooks';
import { Main as CreateCustomBracketSetForm } from '../../../CustomBracketSets/FormDialog';
import {
  closeCustomBracketSetForm,
  updateCustomBracketSetAction
} from '../../../../reducers/customBracketSets';

const Main = ({ openButtonClassName }) => {
  const { rxForm } = useRxForm();
  const request = rxForm?.custom_bracket_set;
  const [localState, setLocalState] = useState({
    openForm: false,
    data: {
      id: request?.id,
      name: request?.name,
      teeth: request?.teeth.map(tooth => ({
        tooth_number: tooth.tooth,
        bracket_library_id: tooth.bracket_library_id,
        bracket_library_name: tooth.bracket_library.label
      })),
      assigned_user_ids: null,
      notes: request?.creation_request_notes
    },
    created: rxForm?.custom_bracket_set?.creation_request_status === 2
  });
  const dispatch = useDispatch();
  const saving = useSelector(state => state.customBracketSets.form.saving);

  const onFinish = (id, data) => {
    return dispatch(
      updateCustomBracketSetAction(rxForm.organization_id, id, {
        ...data
      })
    )
      .then(data => {
        setLocalState(prev => ({ ...prev, openForm: false, data }));
      })
      .then(() => dispatch(closeCustomBracketSetForm()));
  };

  if (
    !request ||
    !request.creation_request_status ||
    // completed
    (request.creation_request_status === 2 &&
      rxForm.id !== request?.creation_request_completed_via_rx_form_id)
  ) {
    return '';
  }

  return (
    <>
      <Button
        disabled={localState.created}
        className={openButtonClassName}
        variant="contained"
        size="small"
        color="primary"
        onClick={() => setLocalState(prev => ({ ...prev, openForm: true }))}
      >
        {localState.created ? 'Custom Bracket Set Created' : 'Custom Bracket Set Request'}
      </Button>
      {localState.openForm && !localState.created && (
        <CreateCustomBracketSetForm
          data={localState.data}
          fetchLibraries={() => {}}
          fetchingLibraries={false}
          fetchedLibraries
          canAssignUsers={false}
          fetchUsers={() => {}}
          fetchingUsers={false}
          fetchedUsers
          users={[]}
          create={() => {}}
          update={onFinish}
          saving={saving}
          close={() => setLocalState(prev => ({ ...prev, openForm: false }))}
          libraries={(rxForm.custom_bracket_set.creation_request_bracket_libraries ?? [])
            .filter(library => library.hidden_at === null && library.deleted_at === null)
            .map(library => ({
              id: library.id,
              name: library.label
            }))}
        />
      )}
    </>
  );
};

Main.propTypes = {
  openButtonClassName: PropTypes.string
};

Main.defaultProps = {
  openButtonClassName: null
};

export default Main;
